import React from "react";
import {IconSource} from "../../../../shared/enums/iconSource";
import {useStores} from "../../../../stores/useStores";
import {observer} from "mobx-react-lite";
import "./metricsHeader.sass";
import Tag from "../../../../components/atoms/tag/tag";
import {KeyValue} from "../../../../stores/observables/keyValue";
import {MultiVillageHelper} from "../../../../shared/multiVillageHelper";
import {
  allVillageKeyValue,
  allVillagesInAU,
  allVillagesInNZ
} from "../../../../shared/constants";
import ButtonIcon from "../../../../components/atoms/button/buttonIcon";
import {format} from "date-fns";
import MetricsCsvWrapper from "../metricsCsvWrapper/metricsCsvWrapper";

export interface IMetricsHeaderProps {
  loadData: () => void;
  loading: boolean;
}

const MetricsHeader: React.FC<IMetricsHeaderProps> = ({loading, loadData}) => {
  const {
    domainStore: {
      metricsDomainStore: {searchParams, getVillageMap, isSearchValid}
    }
  } = useStores();

  const formatCalendarType = () => {
    switch (searchParams?.selectedCalendarType) {
      case "Enhanced":
        return <Tag text={"Enhanced"} type={"digital"} />;
      case "Engage":
        return <Tag text={"Engage"} type={"system"} />;
      case "All":
        return <Tag text={"All Calendars"} type={"neutral"} />;
      default:
        return;
    }
  };

  const formatDate = (date?: Date) => {
    if (date) return format(date, "dd/MM/yyyy");

    return "-";
  };

  const formatSelectedVillages = (selectedVillages: KeyValue[]) => {
    const villagesByCountry = getVillageMap();

    const createTagForVillage = (text: string) => (
      <Tag text={text} type={"neutral"} key={text} />
    );

    const summary = MultiVillageHelper.summariseSelectedVillages(
      selectedVillages,
      villagesByCountry
    );

    if (summary.allVillagesSelected)
      return createTagForVillage(allVillageKeyValue.label);

    const tags: JSX.Element[] = [];
    if (summary.allNZSelected) {
      tags.push(createTagForVillage(allVillagesInNZ.label));
    }
    if (summary.allAUSelected) {
      tags.push(createTagForVillage(allVillagesInAU.label));
    }
    if (summary.selectedVillages.length > 5) {
      tags.push(
        createTagForVillage(
          summary.selectedVillages.length + " villages selected"
        )
      );
      return tags;
    }
    return [
      ...tags,
      ...summary.selectedVillages.map((v) => {
        return createTagForVillage(v.code);
      })
    ];
  };

  return (
    <>
      <div className="metrics-header">
        <div>
          Metrics
          {searchParams && (
            <div className={"summary-tags"}>
              <Tag
                type={"success"}
                text={"From " + formatDate(searchParams.startDate)}
              />
              <Tag
                type={"success"}
                text={"To " + formatDate(searchParams.endDate)}
              />
              {formatCalendarType()}
              {formatSelectedVillages(searchParams.selectedVillages)}
            </div>
          )}
        </div>
        <div className="actions">
          <ButtonIcon
            onClick={loadData}
            isBusy={loading}
            icon={IconSource.search}
            isDisabled={!isSearchValid}
          >
            Search
          </ButtonIcon>
          <MetricsCsvWrapper />
        </div>
      </div>
    </>
  );
};

export default observer(MetricsHeader);
